<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มเวลาการทำงานเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขเวลาการทำงานเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="d-flex justify-space-between card_role_team">
            <div class="mr-1">
                <v-form ref="form" @submit.prevent="addHoursWorked()">
                    <div class="mb-2">
                        <h3>{{ edit_id !== null ? 'แก้ไข' : 'เพิ่ม'}}เวลาการทำงาน</h3>
                    </div>
                    <v-text-field label="ชื่อกะ เวลาการทำงาน" v-model="work_shift_name" color="primary" :rules="[v => !!v || 'กรุณากรอกชื่อกะ เวลาการทำงาน']" required outlined></v-text-field>
                    <v-select label="เวลาเริ่มต้น" :items="$store.state.timeHoursWorkedList" v-model="time_start" :rules="[v => !!v || 'กรุณาเลือกเวลาเริ่มต้น']" required outlined>
                    </v-select>
                    <v-select label="เวลาสิ้นสุด" :items="$store.state.timeHoursWorkedList" v-model="time_end" :rules="[v => !!v || 'กรุณาเลือกเวลาสิ้นสุด']" required outlined>
                    </v-select>
                    <v-btn class="title_font_rolelist white--text grad-primary-bg" width="100%" height="50" type="submit">
                        บันทึก
                    </v-btn>
                </v-form>
            </div>
            <div class="ml-1">
                <v-card>
                    <v-card-title>
                        <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="data" :search="search">
                        <template v-slot:item="dataDetail">
                            <tr>
                                <td>{{dataDetail.item.number}}</td>
                                <td>{{dataDetail.item.work_shift_name}}</td>
                                <td>{{dataDetail.item.time_start}}</td>
                                <td>{{dataDetail.item.time_end}}</td>
                                <td>

                                    <span class="edit_data_rolelist" @click="detailWorkShift(dataDetail.item.id)">
                                        <v-icon dark right color="grey">mdi-pencil-box-outline</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import hoursworked from '@/api/team/teamsetting/hoursworked.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show_add: false,
            alert_show_edit: false,
            edit_id: null,
            work_shift_name: null,
            time_start: null,
            time_end: null,
            search: '',
            headers: [{
                    text: '#',
                    align: 'start',
                    value: 'number',
                },
                {
                    text: 'รายการ',
                    value: 'work_shift_name'
                },
                {
                    text: 'เวลาเริ่มต้น',
                    value: 'time_start'
                },
                {
                    text: 'เวลาสิ้นสุด',
                    value: 'time_end'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
        }
    },
    methods: {
        async hoursWorkedList() {
            this.loading_page = true
            hoursworked.hoursWorkedList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.workshift
                    response.data.workshift.forEach((detail, index) => {
                        this.data[index]['number'] = index + 1
                    })
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async detailWorkShift(id) {
            hoursworked.detailWorkShift(id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_id = response.data.workshift_edit.id
                    this.work_shift_name = response.data.workshift_edit.work_shift_name
                    this.time_start = response.data.workshift_edit.time_start
                    this.time_end = response.data.workshift_edit.time_end
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async addHoursWorked() {
            if (this.$refs.form.validate()) {
                this.loading_page = true
                const data = {
                    work_shift_name: this.work_shift_name,
                    time_start: this.time_start,
                    time_end: this.time_end,
                }
                if (this.edit_id === null) {
                    hoursworked.addWorkShift(data).then((response) => {
                        if (response.data.successful === true) {
                            this.work_shift_name = null
                            this.time_start = null
                            this.time_end = null
                            this.hoursWorkedList()
                            this.alert_show_add = true
                            setTimeout(() => this.alert_show_add = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                } else {
                    hoursworked.editWorkShift(this.edit_id, data).then((response) => {
                        if (response.data.successful === true) {
                            this.edit_id = null
                            this.work_shift_name = null
                            this.time_start = null
                            this.time_end = null
                            this.hoursWorkedList()
                            this.alert_show_edit = true
                            setTimeout(() => this.alert_show_edit = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
            }
        }
    },
    mounted() {
        this.hoursWorkedList()
    }
}
</script>
